var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEyeOff(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "eye-off"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 5110"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M4.95 13.0501C6.11551 13.9385 7.5347 14.4307 9 14.4546C13.7727 14.4546 16.5 9.00009 16.5 9.00009C15.6519 7.41957 14.4756 6.03869 13.05 4.95009M10.4318 3.70919C9.9625 3.59933 9.482 3.54442 9 3.54555C4.22727 3.54555 1.5 9.00009 1.5 9.00009C1.91388 9.77437 2.40746 10.5033 2.97273 11.1751M7.55455 10.4455C7.74181 10.6465 7.96763 10.8077 8.21853 10.9195C8.46944 11.0313 8.7403 11.0914 9.01494 11.0963C9.28958 11.1011 9.56239 11.0506 9.81709 10.9477C10.0718 10.8448 10.3031 10.6917 10.4974 10.4975C10.6916 10.3032 10.8447 10.0719 10.9476 9.81718C11.0505 9.56248 11.101 9.28968 11.0962 9.01503C11.0913 8.74039 11.0312 8.46953 10.9194 8.21863C10.8076 7.96772 10.6464 7.7419 10.4455 7.55464",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M15.1362 2.86377L2.8635 15.1365",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeOff);
export default __webpack_public_path__ + "static/media/EyeOff.649f2fc98b6bf83e8ade13897fd29147.svg";
export { ForwardRef as ReactComponent };